import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Button from "./components/Button";
import { setGameData, toggleGame, setRoomType, addPlayerToRoom,resetGameStatus, startCountDown, resetGameState, toggleLoader, setIsJoiningRoom, showToast, setCountDown, setPracticeCountdownStartTime, setCountDownState, setNotStart } from "./redux/stores/GameStore";
import { loadGameAssets } from "./gaming_components/LoadGame/LoadGame";
import { socket } from "./socket";
import useHotKey from "./hooks/useHotKey";
import "./MainMenu.scss";
import "./section.scss";
export default function MainMenu(){    
    const [ displayButtons, setDisplayButtons ] = useState(true);
    const { gamePage, solo_id, room, isJoiningRoom } = useSelector(state => state.game);
    const dispatch = useDispatch();    
    const loadPracticeGame = async() =>{            
        try{
            const { gameData } = await loadGameAssets(solo_id,room.gameType);            
            dispatch(addPlayerToRoom({player_id: solo_id}));
            dispatch(setGameData({gameData:gameData}));
            dispatch(toggleLoader());
            // Start countdown immediately for solo practice games
            dispatch(setCountDown({second:3}));
            dispatch(setPracticeCountdownStartTime({timestamp: Date.now()}));
            dispatch(setCountDownState({newState:true}));
            dispatch(setNotStart({newState:true}));
            dispatch(toggleGame());
        }catch(err){
            throw Error(err);
        }
    }
    const startMultiplayerGame = () => {
        // Prevent double-clicks and multiple join attempts
        if (!displayButtons || isJoiningRoom) {
            return;
        }
        
        dispatch(resetGameState());
        dispatch(setRoomType({gameType: "MULTIPLAYER"}));
        setDisplayButtons(false);
        dispatch(setIsJoiningRoom({isJoining: true}));
        dispatch(toggleLoader());
        socket.emit('join room');
    }
    const startPracticeGame = async() => {
        if (displayButtons){
            dispatch(resetGameState());
            dispatch(setRoomType({gameType: "PRACTICE"}));
            setDisplayButtons(false);
            dispatch(toggleLoader());
            try {
                await loadPracticeGame();
            }
            catch(err){
                console.log(err)
            }
        }
    }
    const handleHotKeyPress = (event) => {
        switch(event.key) {
            case 'm':
                startMultiplayerGame();
                break;
            case 'p':
                startPracticeGame();
                break;
            default:
                console.log(`You've pressed: ${event.key}`);
                break;
        }
    }
    useHotKey(['m','p'],handleHotKeyPress);
    useEffect(()=>{
        // a function that dispatches the correct data on their respective events        
        const loadMultiplayerGame = (data) => {            
            const {gameData} = data;
            const gameAssets = {
                text: gameData.text,
                totalCharacters: gameData.totalCharacters,
                estimatedTime: gameData.estimatedTime,                
            }
            dispatch(resetGameStatus());
            const playerAssets = gameData.player_ids; // existing players            
            if(playerAssets.length > 0){
                playerAssets.forEach((ID) => {
                    dispatch(addPlayerToRoom({player_id: ID}));
                });                
            }                        
            dispatch(addPlayerToRoom({player_id:socket.id}));
            
            dispatch(setGameData({gameData:gameAssets}));     
            dispatch(toggleLoader());
            dispatch(startCountDown());
            dispatch(toggleGame());
            // Re-enable buttons on successful join
            dispatch(setIsJoiningRoom({isJoining: false}));
            setDisplayButtons(true);
        }
        
        const handleJoinError = (error) => {
            console.error('Join error in MainMenu:', error);
            dispatch(setIsJoiningRoom({isJoining: false}));
            dispatch(toggleLoader());
            setDisplayButtons(true);
            // Error toast is already handled by socket.js, but we can add a specific one here if needed
            if (error?.message) {
                dispatch(showToast({ 
                    message: error.message || 'Failed to join room', 
                    type: 'error' 
                }));
            }
        }
                
        socket.on("game room data", loadMultiplayerGame);
        socket.on("join_error", handleJoinError);
        socket.on("room_error", handleJoinError);
        
        return ()=>{
            socket.off("game room data", loadMultiplayerGame);
            socket.off("join_error", handleJoinError);
            socket.off("room_error", handleJoinError);
        }
    }, [dispatch]);    
    return (
        <section>
            <h1 className="neon-text">RACE TYP3</h1>        
            <section
            className={`main-menu section${gamePage ? ' section--r':''} flex flex-row`}
            >            
                {
                displayButtons && 
                    <Button 
                        classes="neon-button" 
                        text={isJoiningRoom ? "Joining..." : "Enter a Typing Racer"}
                        action={startMultiplayerGame}
                        hotkey="m"
                        disabled={isJoiningRoom}
                    />
                }
                {
                displayButtons &&
                    <Button 
                        classes="neon-button" 
                        text="Practice Race"
                        action={startPracticeGame}
                        hotkey="p"
                    />
                }                
            </section>
        </section>
    );
}
